import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ChevronLeftSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ChevronLeftSVG;
